import Spark from 'app/assets/icons/SmartDocs/Spark.svg'
import { Box, Button, Flex } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { NEXT_GEN_LEASING_URL } from 'app/utils/text/helpers'

function SmartDocsTextLogo({
  withLearnMore = false,
  checkedItem = 0,
  foundItems = 0,
}) {
  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      alignItems="end"
      fontWeight="700"
      mb={4}
    >
      <Flex alignItems="end">
        <Box fontSize="22px" fontWeight="700">
          SmartDocs
        </Box>
        <Box mb={3}>
          <img
            src={Spark}
            alt="SmartDocs Icon"
            width={theme.width[6] + 'px'}
            height={theme.height[6] + 'px'}
          />
        </Box>
        {withLearnMore && (
          <Button
            sizeVariant="extraSmall"
            variant="linkBlueWithoutWeight"
            fontSize={theme.fontSizes.pSmall12}
            onClick={() => {
              window.open(NEXT_GEN_LEASING_URL, '_blank')
            }}
            ml={5}
          >
            learn more
          </Button>
        )}
      </Flex>
      <Box ml={4} fontSize={theme.fontSizes.pLarge16} fontWeight="500">
        {foundItems > 0 ? `${foundItems} items` : ''} ({checkedItem} checked)
      </Box>
    </Flex>
  )
}

export default SmartDocsTextLogo
